export default "__VITE_ASSET__8898177d__"